/**
 * Direct WhatsApp share — opens the WhatsApp app (mobile) or
 * WhatsApp Desktop / Web (desktop) with a pre-filled message.
 *
 * When the product has a `photo_url`, it is placed on the first
 * line of the body so WhatsApp's link-preview auto-renders the
 * image thumbnail above the text in the chat bubble.
 *
 * No file fetching, no Web Share API, no toasts. Same behaviour
 * on every browser and device.
 */

// Re-using the same window name causes browsers to reuse the
// existing WhatsApp tab/window on subsequent share clicks
// (so the user doesn't get re-prompted to log in every time).
const WHATSAPP_WINDOW_NAME = "aps_whatsapp_share";

export function shareToWhatsApp({ text, photoUrl } = {}) {
  const body = photoUrl ? `${photoUrl}\n\n${text}` : text;
  const enc = encodeURIComponent(body);
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  if (isMobile) {
    // Mobile: WhatsApp app intercepts the whatsapp:// scheme.
    window.location.href = `whatsapp://send?text=${enc}`;
  } else {
    // Desktop: wa.me is WhatsApp's canonical short link. It opens
    // WhatsApp Desktop if installed, otherwise WhatsApp Web — and
    // re-uses an open WhatsApp Web tab if the user is already in.
    window.open(`https://wa.me/?text=${enc}`, WHATSAPP_WINDOW_NAME);
  }
}
